// Collapsible content custom JS

document.addEventListener('DOMContentLoaded', function () {
  const accordionItems = document.querySelectorAll('.custom-collapsible-section .accordion-item');

  accordionItems.forEach((item) => {
    const content = item.querySelector('.accordion-content');
    if (item.classList.contains('open')) {
      content.style.maxHeight = content.scrollHeight + 'px';
    } else {
      content.style.maxHeight = 0;
    }
  });

  accordionItems.forEach((item) => {
    const title = item.querySelector('.accordion-title');
    const content = item.querySelector('.accordion-content');

    title.addEventListener('click', () => {
      if (item.classList.contains('open')) {
        item.classList.remove('open');
        content.style.maxHeight = 0;
      } else {
        accordionItems.forEach((otherItem) => {
          otherItem.classList.remove('open');
          const otherContent = otherItem.querySelector('.accordion-content');
          otherContent.style.maxHeight = 0;
        });

        item.classList.add('open');
        content.style.maxHeight = content.scrollHeight + 'px';
      }
    });
  });
});



// Video Reviews JS
document.addEventListener('DOMContentLoaded', function () {
  /******VIDEO REVIEWS SLIDER*******/
  const videoReviewSlider = new Swiper(".video--review--slider", {
    spaceBetween: 17,
    breakpoints: {
      320: {
        slidesPerView: 1.5,
        spaceBetween: 12
      },
      480: {
        slidesPerView: 2.2,
        spaceBetween: 15
      },
      750: {
        slidesPerView: 3.2
      },
      1024: {
        slidesPerView: 4
      }
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    }
  });

  /******VIDEO PLAYING FUNCTIONALITY*****/
  const playTriggers = document.querySelectorAll("[playTrigger]");
  playTriggers.forEach(function (playButton) {
    playButton.addEventListener("click", function () {
      const video = this.closest("[videoWrapper]").querySelector("video");
      video.play();
      this.classList.add("hidden");
    });
  });

  const videoElements = document.querySelectorAll("[videoWrapper] video");
  videoElements.forEach(function (video) {
    video.addEventListener("click", function () {
      if (!this.paused && !this.ended) {
        this.pause();
        this.closest("[videoWrapper]").querySelector("[playTrigger]").classList.remove("hidden");
      }
    });

    video.addEventListener("ended", function () {
      const playButton = this.closest("[videoWrapper]").querySelector("[playTrigger]");
      playButton.classList.remove("hidden");
      this.load();
    });
  });
});



// Featured collection v2 JS
document.addEventListener('DOMContentLoaded', function () {
  const videoReviewSlider = new Swiper(".featured-col-v2-slider", {
    spaceBetween: 8,
    breakpoints: {
      320: {
        slidesPerView: 1.5
      },
      480: {
        slidesPerView: 2.2
      },
      750: {
        slidesPerView: 3.2
      },
      1024: {
        slidesPerView: 4
      }
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    }
  });
});


// Testimonial Slider JS
document.addEventListener('DOMContentLoaded', function () {
  const videoReviewSlider = new Swiper(".testimonial-slider", {
    spaceBetween: 10,
    loop: true,
    speed: 500,
    centeredSlides: false,
    // autoplay: {
    //   delay: 5000,
    //   disableOnInteraction: false,
    // },
    breakpoints: {
      320: {
        slidesPerView: 1.2
      },
      480: {
        slidesPerView: 2.2,
        centeredSlides: false,
      },
      750: {
        slidesPerView: 2,
        spaceBetween: 20,
      },
      1024: {
        slidesPerView: 3,
        spaceBetween: 24,
        centeredSlides: true,
        speed: 700
      }
    },
  });
});


// Footer Accordion Mobile JS

document.addEventListener('DOMContentLoaded', function() {
  function initializeAccordion() {
    var footerMenus = document.querySelectorAll('.footer-block.footer-block--menu');

    footerMenus.forEach(function(menu) {
      var header = menu.querySelector('.footer-block__heading');
      var content = menu.querySelector('.footer-block__details-content');

      if (header && content) {
        if (window.innerWidth <= 768) {
          header.classList.add('accordion-header');
          content.classList.add('accordion-content');

          header.addEventListener('click', toggleAccordion);
        } else {
          header.classList.remove('accordion-header', 'active');
          content.classList.remove('accordion-content', 'active');
          content.style.maxHeight = null;

          header.removeEventListener('click', toggleAccordion);
        }
      }
    });
  }

  function toggleAccordion() {
    var header = this;
    var content = header.nextElementSibling;

    header.classList.toggle('active');
    content.classList.toggle('active');

    if (content.style.maxHeight) {
      content.style.maxHeight = null;
    } else {
      content.style.maxHeight = content.scrollHeight + 'px';
    }
  }

  initializeAccordion();

  window.addEventListener('resize', initializeAccordion);
});

